export default __webpack_public_path__ + "static/media/6.61fde455.png";